import React from 'react'


const EnergyAndRevenue = () => {
  return (
    <div>
       
      <h1>
        my name is energy and revenue.  
      </h1>
    </div>
  )
}

export default EnergyAndRevenue;
